import { Injectable, inject } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class VerificationService {
  private http = inject(HttpClient);


  sendVerificationCode(){
    return this.http.post(environment.backendApi+'/api/send-code/', {}).subscribe();
  }

  verifyCode(code: string){
    return this.http.post(environment.backendApi+'/api/verifiy-code/', {code});
  }
}
